<template lang="pug">
	.network-show--detail.network-show--talent-detail.flex-col.space(v-if="item")
		template(v-if="editing")
			.flex-col.space-large
				.flex-row.space-medium.align-start
					.flex-col
						.flex-row
							.adt-tab.small.no-bottom-border.top.flex-1(@click="imageTab = 'logo'", :class="{ active: imageTab === 'logo' }") {{$tCaption('Logo')}}
							.adt-tab.small.no-bottom-border.top.flex-1.clickable(@click="imageTab = 'photo'", :class="{ active: imageTab === 'photo' }") {{$tCaption('Photo')}}
						ImageEditor(ref="photo", v-show="imageTab === 'photo'", :objectId="item.Oid", :objectType="$Data.objectTypes.NetworkShowTalent", :url="item.PhotoUrl", size="160px", fieldName="Photo", :cropSizes="[640, 640]")
						ImageEditor(ref="logo", v-show="imageTab === 'logo'", :objectId="item.Oid", :objectType="$Data.objectTypes.NetworkShowTalent", :url="item.LogoUrl", size="160px", fieldName="Logo", :cropSizes="[256, 256]")
					.flex-col.space.flex-1
						EditableLabelField(:caption="$tCaption('Name')", :value.sync="item.Name", type="text", stylingMode="filled", :editingMode="true")
						EditableLabelField(:caption="$tCaption('Bio')", :value.sync="item.Bio", type="area", stylingMode="filled", :editingMode="true", :editorOptions="{ height: '97px' }")
				.flex-col.space
					.flex-row.space
						EditableLabelField(:caption="$tCaption('Facebook')", :value.sync="item.Facebook", type="text", stylingMode="filled", icon="fa-brands fa-facebook", :editingMode="true")
						EditableLabelField(:caption="$tCaption('Instagram')", :value.sync="item.Instagram", type="text", stylingMode="filled", icon="fa-brands fa-instagram", :editingMode="true")
					.flex-row.space
						EditableLabelField(:caption="$tCaption('Linkedin')", :value.sync="item.Linkedin", type="text", stylingMode="filled", icon="fa-brands fa-linkedin", :editingMode="true")
						EditableLabelField(:caption="$tCaption('TikTok')", :value.sync="item.TikTok", type="text", stylingMode="filled", icon="fa-brands fa-tiktok", :editingMode="true")
					.flex-row.space
						EditableLabelField(:caption="$tCaption('Twitter')", :value.sync="item.Twitter", type="text", stylingMode="filled", icon="fa-brands fa-twitter", :editingMode="true")
						.flex-1
		template(v-else)
			.flex-col.space.talent-card(:class="{ linked, searching, editing }")
				.flex-row.space-medium
					.flex-col.align-start
						.photo(v-if="item.PhotoUrl || item.LogoUrl", :style="{ '--url': `url('${item.PhotoUrl || item.LogoUrl }')`}")
					.flex-col.space.center
						.font-big {{item.Name}}
						.grey.bio(v-if="item.Bio") {{getLimited(item.Bio, 100)}}
</template>

<script>
	import EditableLabelField from 'app-core/EditableLabelField.vue';
	import ImageEditor from 'app-core/ImageEditor.vue';

	export default {
		translationCategory: 'networkShow.Talent',
		name: 'network-show--talent-detail',
		props: ['item', 'editing', 'searching', 'linked', 'events'],
		components: {
			EditableLabelField, ImageEditor
		},
		data() {
			return {
				imageTab: 'logo'
			};
		},
		mounted() {
			if (__DEBUG__)
				window.talentDetail = this;
			if (this.events) {
				this.events.afterSave = async (r) => {
					return Promise.all([this.$refs.photo.ensureSaved({ ObjectId: r?.Oid }), this.$refs.logo.ensureSaved({ ObjectId: r?.Oid })])
						.then((images) => {
							this.$set(this.item, 'PhotoUrl', images[0]);
							this.$set(this.item, 'LogoUrl', images[1]);
						});
				}
			}
		},
		methods: {
			getLimited(txt, limit) {
				const result = this.searching ? (txt || '').substr(0, limit) : txt;
				return result + (result.length < txt?.length ? '..' : '');
			}
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.network-show--talent-detail {
		.talent-card {
			&.searching {
				cursor: pointer;
			}

			transition: 0.3s;

			.photo {
				width: 100px;
				height: 100px;
				background: var(--url);
				background-size: cover;
				background-position: center;
				border-radius: 100px;
				border: 2px solid #fff;
				transition: 0.3s;
			}

			&.searching {
				.photo {
					width: 60px;
					height: 60px;
					background: var(--url);
					background-size: cover;
					background-position: center;
					border-radius: 40px;
					border: 4px solid #e0e0e0;
				}
			}
			

			&.searching:hover {
				color: $base-accent;

				.photo {
					transform: scale(1.15);
				}
			}
		}
	}
</style>
